export enum DefaultGroupsIDs {
    shortcuts = 'shortcuts',
    insights = 'insights'
}

export enum HomepageGroupType {
    portlet = 'P',
    tile = 'T'
}
